import _ from 'lodash';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    loadTermsList,
    selectCountry,
    getFilteredList,
    searchForTerm
} from '../actions';

import enAUFlag from '../../assets/images/en-AU.svg';
import enUSFlag from '../../assets/images/en-US.svg';
import esESFlag from '../../assets/images/es-ES.svg';
import esLAFlag from '../../assets/images/es-LA.svg';
import { getValueFromQueryString, formatLocale } from '../../helpers/utils';

////////////////////////////////////////////////////
// Search component could do with some TLC:
// 1. the list of categories is hard-coded and
//    could be stored as a data file at least.
// 2. If stored as a data file, we could translate
//    to different languages.
////////////////////////////////////////////////////

class Search extends Component {
    componentDidMount(){
      const locale = getValueFromQueryString('locale');
      if (locale && formatLocale(locale)) {
        this.getCountryData(formatLocale(locale));
      }
    }

    searchSubmit(e){
        e.preventDefault();
        this.props.searchForTerm(e.target.content.value);
    }

    getCountryData(country){
        this.props.selectCountry(country);
        this.props.loadTermsList(country);
        this.props.getFilteredList('all');
    }

    render(){
        let shownFlag;
        switch (this.props.country) {
            case 'en-AU':
                shownFlag = enAUFlag;
                break;
            case 'en-US':
                shownFlag = enUSFlag;
                break;
            case 'es-ES':
                shownFlag = esESFlag;
                break;
            case 'es-LA':
                shownFlag = esLAFlag;
                break;
        }

        return(
            <div className="search-div">
                <form className="search-box"
                      onSubmit={this.searchSubmit.bind(this)}>
                    <input type="text" name="content" className="form-control search" autoComplete="off" placeholder="Search" />
                    <button type="submit" className="searchbutton"> </button>
                </form>

                <div className="country dropdown">
                    <a className="padding-right dropbtn">
                        <img src={shownFlag}/><span className="caret"> </span>
                    </a>
                    <div className="dropdown-content">
                        <a onClick={() => this.getCountryData('en-AU')}><img src={enAUFlag}/> AUS</a>
                        <a onClick={() => this.getCountryData('en-US')}><img src={enUSFlag}/> USA</a>
                        <a onClick={() => this.getCountryData('es-ES')}><img src={esESFlag}/> Trad.</a>
                        <a onClick={() => this.getCountryData('es-LA')}><img src={esLAFlag}/> Intl.</a>
                    </div>
                </div>

            </div>
        );
    }
}

function mapStateToProps(state){
    return {
        country: state.mathsDictionary.countryFilter,
        termsList: state.mathsDictionary.termsList,
        filteredList: state.mathsDictionary.filteredList,
        searchTerm: state.mathsDictionary.searchTerm
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        selectCountry,
        loadTermsList,
        getFilteredList,
        searchForTerm
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Search)


/*

return(
            <div className="search-div">
                <form className="search-box"
                      onSubmit={this.searchSubmit.bind(this)}>
                    <input type="text" name="content" className="form-control search" autoComplete="off" placeholder="Search" />
                    <button type="submit" className="searchbutton"> </button>
                </form>


                <div className="dropdown category">
                    <a className="dropbtn">{activeCategoryName}<span className="caret"></span></a>
                    <div className="dropdown-content">
                        {categoryList}
                    </div>
                </div>

                <div className="country dropdown">
                    <a className="padding-right dropbtn">
                        <img src={`assets/images/${this.props.country}.svg`}/><span className="caret"> </span>
                    </a>
                    <div className="dropdown-content">
                        <a onClick={() => this.getCountryData('aus')}><img src='assets/images/aus.svg'/> AUS</a>
                        <a onClick={() => this.getCountryData('usa')}><img src='assets/images/usa.svg'/> USA</a>
                        <a onClick={() => this.getCountryData('eps')}><img src='assets/images/eps.svg'/> Trad.</a>
                        <a onClick={() => this.getCountryData('epsl')}><img src='assets/images/eps.svg'/> Intl.</a>
                    </div>
                </div>

            </div>
        );



 */
